/* eslint-disable react/state-in-constructor */
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import { styled } from '@mui/material/styles';
import InputAdornment from '@mui/material/InputAdornment';
import SendIcon from '@mui/icons-material/Send';
import './_commentSection.scss';

type Props = {
    show: boolean;
    canEdit: boolean;
    t: TranslationT;
    submitComment: FlowAnyFunction;
    children: React.ReactNode;
    maxHeight: number;
};
type State = {
    commentContent: string;
};

const StyCommentList = styled(List, {
    name: 'StyCommentList',
})({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
});

class CommentSection extends React.Component<Props, State> {
    state = { commentContent: '' };

    // @ts-expect-error [TS migration] Was not detected by flow
    handleCommentEntry = (e) => {
        this.setState({ commentContent: e.target.value });
    };

    // @ts-expect-error [TS migration] Was not detected by flow
    handleCommentEnter = (keyPress) => {
        if (keyPress.key === 'Enter') {
            keyPress.preventDefault();
            this.handleCommentSubmit();
        }
    };

    handleCommentSubmit = () => {
        this.props.submitComment(this.state.commentContent);
        this.setState({ commentContent: '' });
    };

    render() {
        if (!this.props.show) {
            return null;
        }

        return (
            <div
                className="comment-section"
                style={{
                    maxHeight: this.props.maxHeight,
                    minHeight: this.props.maxHeight,
                }}
            >
                <StyCommentList>{this.props.children}</StyCommentList>
                {this.props.canEdit && (
                    <div className="comment-text-field">
                        <TextField
                            variant="standard"
                            placeholder={this.props.t(
                                'commentSection.addComment',
                            )}
                            fullWidth
                            onChange={this.handleCommentEntry}
                            onKeyPress={this.handleCommentEnter}
                            value={this.state.commentContent}
                            multiline
                            maxRows={5}
                            InputProps={{
                                name: 'add-comment',
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            color="primary"
                                            onClick={this.handleCommentSubmit}
                                            className="add-comment-button e2e-add-comment-button"
                                            size="large"
                                        >
                                            <SendIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                )}
            </div>
        );
    }
}

const TranslatedCommentSection = withTranslation('components')(CommentSection);
TranslatedCommentSection.displayName = 'CommentSection';
export default TranslatedCommentSection;
